<div class="modal-overlay" (click)="fechar()"></div>

<div class="modal-panel">

  <div class="sucesso-screen" *ngIf="sucesso">
    <div class="sucesso-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    </div>
    <h2 class="sucesso-title">Solicitação enviada!</h2>
    <p class="sucesso-desc">
      Recebemos sua solicitação de pesquisa. Nossa equipe irá analisar e entrar em contato em breve.
    </p>
    <button class="btn-primary" (click)="fechar()" type="button">Fechar</button>
  </div>

  <ng-container *ngIf="!sucesso">

    <div class="modal-header">
      <div class="modal-header-left">
        <div class="modal-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </div>
        <div>
          <h2 class="modal-title">Solicitar pesquisa de obra</h2>
          <p class="modal-subtitle">Informe os dados da obra que deseja pesquisar</p>
        </div>
      </div>
      <button class="btn-close" (click)="fechar()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="modal-body">

      <div class="form-row">
        <div class="form-group form-group--obra">
          <label class="form-label">Nome da obra</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="workName"
            placeholder="Ex: Residencial Park Avenue"
            maxlength="500"
          />
        </div>

        <div class="form-group form-group--modulo">
          <label class="form-label">
            Módulo
            <span class="required">*</span>
          </label>
          <select
            class="form-select"
            [class.form-input--error]="submitted && !moduloId"
            [(ngModel)]="moduloId"
          >
            <option [ngValue]="null">Selecione</option>
            <option *ngFor="let modulo of modulos" [ngValue]="modulo.value">{{ modulo.label }}</option>
          </select>
          <span class="error-msg" *ngIf="submitted && !moduloId">Selecione</span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Cidade</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="city"
            placeholder="Ex: São Paulo"
            maxlength="200"
          />
        </div>

        <div class="form-group form-group--estado">
          <label class="form-label">
            Estado
            <span class="required">*</span>
          </label>
          <select
            class="form-select"
            [class.form-input--error]="submitted && !state"
            [(ngModel)]="state"
          >
            <option value="">UF</option>
            <option *ngFor="let uf of estados" [value]="uf">{{ uf }}</option>
          </select>
          <span class="error-msg" *ngIf="submitted && !state">Selecione</span>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Construtora</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="constructorName"
          placeholder="Ex: Cyrela, MRV, Tenda..."
          maxlength="300"
        />
      </div>

      <div class="form-group">
        <label class="form-label">
          Mensagem
          <span class="required">*</span>
        </label>
        <textarea
          class="form-textarea"
          [class.form-textarea--error]="submitted && !message.trim()"
          [(ngModel)]="message"
          placeholder="Adicione informações que possam ajudar na pesquisa..."
          rows="4"
          maxlength="2000"
        ></textarea>
        <div class="textarea-footer">
          <span class="error-msg" *ngIf="submitted && !message.trim()">A mensagem é obrigatória</span>
          <span class="char-count">{{ message.length }}/2000</span>
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <button class="btn-secondary" (click)="fechar()">Cancelar</button>
      <button class="btn-primary" (click)="enviar()" [disabled]="enviando" type="button">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
        Enviar solicitação
      </button>
    </div>

  </ng-container>

</div>